import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { SectionCTA } from './SectionCTA';
const steps = ['Open the volumes.', 'Explore the planning frameworks.', 'Review the worksheets.', 'Use the checklists.', 'Test the case-planning system.'];
export function Guarantee() {
  return <section className="bg-ink px-4 py-16 text-white" aria-labelledby="g-title" data-id="element-156" data-mp="1x422hbifsm65">
      <div className="mx-auto max-w-2xl text-center" data-id="element-157" data-mp="19eheufbc90qj">
        <div className="mx-auto flex h-28 w-28 flex-col items-center justify-center rounded-full border-4 border-gold bg-ink-soft" data-id="element-158" data-mp="19f0ol8qu4ith">
          <ShieldCheckIcon className="h-9 w-9 text-gold" aria-hidden="true" data-id="element-159" data-mp="1j4k7geejscoc" />
          <span className="mt-1 font-serif text-2xl font-bold leading-none text-gold-light" data-id="element-160" data-mp="1j6n7zsdbto7b">7 Days</span>
        </div>
        <p className="mt-6 text-sm font-bold uppercase tracking-widest text-gold" data-id="element-161" data-mp="qo9geail2ygo">7-day guarantee</p>
        <h2 id="g-title" className="mt-2 font-serif text-[2rem] font-bold leading-tight sm:text-5xl" data-id="element-162" data-mp="lp6bcq2lss8p">
          Try Sculptor’s Operating Blueprint™ <span className="italic text-gold" data-id="element-163" data-mp="oygowo9mduf1">risk-free</span>
        </h2>
        <ul className="mx-auto mt-7 inline-flex flex-col gap-2 text-left text-lg text-white/85" data-id="element-164" data-mp="ty2z0ou5iujm">
          {steps.map(s => <li key={s} className="flex items-center gap-3" data-id="element-165" data-mp="yqmddo0nxtph">
              <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-gold" aria-hidden="true" data-id="element-166" data-mp="12qof1x6een4r" />
              {s}
            </li>)}
        </ul>
        <p className="mt-7 text-base leading-relaxed text-white/70" data-id="element-167" data-mp="628gxcp835g1">
          If within the first 7 days you decide that Sculptor’s Operating Blueprint™ isn’t a useful addition to your
          professional education and reference library, request a refund according to the purchase terms.
        </p>
        <SectionCTA label="Try it for 7 days" tone="dark" data-id="element-168" data-mp="k1q8u0xteytm" />
      </div>
    </section>;
}